angular.module("mapes").controller("CercaAvancadaController", CercaAvancadaController);

function CercaAvancadaController(
  $scope,
  $rootScope,
  EnsenyamentsData,
  EnsenyamentsPreinscripcio,
  EnsenyamentsPreinscripcioCercaService,
  Naturaleses,
  EnsenyamentsPreinscripcioData,
  Torns,
  Regims,
) {
  var $ctrl = this;

  //Input variables
  $ctrl.type = undefined;
  $ctrl.listTipusEnsenyament = [];
  $ctrl.nivells = [];
  $ctrl.naturaleses = [];
  $ctrl.torns = [];
  $ctrl.regims = [];

  //Lists
  $ctrl.llistaEnsenyaments = [];
  $ctrl.selTipusEnsenyament = [];
  $ctrl.ariFilter = [];

  //Select tab
  $ctrl.selectCercaTipusTab = 0;

  //Llistes dels multiselects
  $ctrl.subEtapes = [];
  $ctrl.families = [];
  $ctrl.cicles = [];
  $ctrl.estudis = [];

  $ctrl.hasBatxillerats = false;
  $ctrl.hasFormacioProfesionals = false;

  //Arrays per controlar les opcions dels multiselects
  $ctrl.dataArrays = {};
  $ctrl.ariFilterOptions = {};

  //Literals
  $ctrl.literalsEstudis = {
    MODALITAT_FAMILIA: "Families",
    CICLE_GRAU: "Cicle/Grau",
    ESTUDI: "Estudi",
    SUBSUBETAPA: "Especialitat",
  };

  //Variables de control
  $scope.ensenyaments = [];

  this.$onInit = function () {
    Torns.init().then(function (data) {
      $ctrl.torns = data;
      $ctrl.torns_aux = angular.copy(data);
    });

    Regims.init().then(function (data) {
       $ctrl.regims = data;
       $ctrl.regims_aux = angular.copy(data);
    });

    switch ($ctrl.type) {
      case 1:
        EnsenyamentsPreinscripcio.init().then(function (ensenyaments) {
          $ctrl.llistaEnsenyaments = ensenyaments;
          addTickedToListEnsenyament();
        });
        $ctrl.naturaleses = Naturaleses.getNaturalesesPreinscripcio();
        break;
      case 2:
        EnsenyamentsData.init().then(function (ensenyaments) {
          $ctrl.llistaEnsenyaments = ensenyaments;
          addTickedToListEnsenyament();
        });
        $ctrl.naturaleses = Naturaleses.getNaturaleses();
        break;
    }
  };

  function addTickedToListEnsenyament() {
    //Aquesta funció serveix per afegir la propietat de reset a la llista que li passem
    for (var index in $ctrl.llistaEnsenyaments) {
      $ctrl.llistaEnsenyaments[index].ticked = false;
    }
  }

  //Funcions per interactuar amb el multiselect de tipus d'ensenyament
  $ctrl.onEnsenyamentItemSelected = async function (data) {
    if (data["ticked"]) {
      $ctrl.ariFilter.push({
        tipus: data,
        subsubetapes: [],
        families: [],
        cicles: [],
        estudis: [],
        nivells: [],
        naturaleses: [],
        torns: [],
        regims: [],
      });

      if (data.codi && $ctrl.llistaEnsenyaments != null && checkCodiSuitability(data.codi)) {
        if (data.codi === "BATXLOE") {
          EnsenyamentsPreinscripcioCercaService.getBatxillerats().then(function (response) {
            $ctrl.estudis[data.codi] = response;
            if ($ctrl.estudis[data.codi].length > 0) {
              $ctrl.hasBatxillerats = $ctrl.estudis[data.codi][0].codi !== "X";
              addTickedPropertyToList($ctrl.estudis[data.codi]);
              addLiteralPropertyToList($ctrl.estudis[data.codi]);
            }
            localStorage.setItem('BATXLOE', JSON.stringify(response));
          });
        } else {
          getSubEtapes(data.codi);
          if ($ctrl.cicles[data.codi] != null && $ctrl.cicles[data.codi].length > 0) {
            addTickedPropertyToList($ctrl.cicles[data.codi]);
          }
          if (data.codi === "CFP") {
            const grados = await EnsenyamentsPreinscripcioCercaService.getFormacioProfesionalGraus();
            if (grados.length > 0) {
              $ctrl.hasFormacioProfesionals = grados[0].codi !== "X";
              if ($ctrl.hasFormacioProfesionals) {
                const corespondences = { CFPS: 'CGGS', CFPM: 'CGGM', CFPB: 'CFPB' };
                const gradosSet = new Set(grados.map(g => corespondences[g.codi] || g.codi));
                $ctrl.cicles[data.codi] = $ctrl.cicles[data.codi].filter((cicle) => {
                  return gradosSet.has(cicle.codi);
                });
              }
            }
          }
        }
      }

      $rootScope.familiaFP = data.codi === "CFP";
    } else {
      var index = _.findIndex(_.map($ctrl.ariFilter, "tipus"), function (item) {
        return item.codi === data.codi;
      });
      if (index !== -1) {
        $ctrl.ariFilter.splice(index, 1);
      }
    }
    $ctrl.ariFilter = _.sortBy($ctrl.ariFilter, [
      function (o) {
        return o.tipus.ordre;
      },
    ]);
  };

  //Mira que no haguem seleccionat cap estudi obligatori
  function checkCodiSuitability(codi) {
    return !(codi === "EPRILOE" || codi === "ESO LOE" || codi === "EINFLOE3-6");
  }

  $ctrl.onCicleMultiselectItemSelected = function (data, parent) {
    var parentIndex = _.findIndex($ctrl.ariFilter, function (item) {
      return item.tipus.codi === parent;
    });
    if (data.ticked) {
      var selected_options = getSelectedOptions($ctrl.ariFilter[parentIndex]);
      EnsenyamentsPreinscripcioCercaService.getFamiliesFromGraus(parent, selected_options).then(
        function (families) {
          $ctrl.families[parent] = families;
          addLiteralPropertyToList($ctrl.families[parent]);
          reselectFamilies(parentIndex);
          EnsenyamentsPreinscripcioCercaService.getEstudisFromFamilies(
            parent,
            selected_options,
          ).then(function (estudis) {
            $ctrl.estudis[parent] = estudis;
            addLiteralPropertyToList($ctrl.estudis[parent]);
            reselectEstudis(parentIndex);
          });
        },
      );
    } else {
      deselectGrauFromAriFilter(data.codi, parentIndex);
      deleteFamiliesFromMultiselect(data.codi, parentIndex);
      reselectFamilies(parentIndex);
      deleteEstudisFromMultiselect(parentIndex);
      reselectEstudis(parentIndex);
    }
  };

  $ctrl.onFamiliaMultiselectItemSelected = function (data, parent) {
    var parentIndex = _.findIndex($ctrl.ariFilter, function (item) {
      return item.tipus.codi === parent;
    });
    if (data.ticked) {
      var selected_options = getSelectedOptions($ctrl.ariFilter[parentIndex]);
      EnsenyamentsPreinscripcioCercaService.getEstudisFromFamilies(
        parent,
        selected_options,
      ).then(function (estudis) {
        $ctrl.estudis[parent] = estudis;
        addLiteralPropertyToList($ctrl.estudis[parent]);
        reselectEstudis(parentIndex);
      });
    } else {
      deselectFamiliaFromAriFilter((data.codis || [])[0], parentIndex);
      deleteEstudisFromMultiselect(parentIndex);
      reselectEstudis(parentIndex);
    }
  };

  function addLiteralPropertyToList(list) {
    (list || []).forEach(function (item) {
      item.literal = item.nom;
    });
  }

  function addTickedPropertyToList(list) {
    (list || []).forEach(function (item) {
      item.ticked = false;
    });
  }

  function deselectGrauFromAriFilter(grauCode, parentIndex) {
    _.remove($ctrl.ariFilter[parentIndex].families, function (item) {
      var canBeDeleted = false;
      if (
        item.parent.length === 1 &&
        _.findIndex(item.parent, function (o) {
          return o === grauCode;
        }) >= 0
      ) {
        deselectFamiliaFromAriFilter((item.codis || [])[0], parentIndex);
        canBeDeleted = true;
      }
      return canBeDeleted;
    });
    _.remove($ctrl.ariFilter[parentIndex].cicles, function (item) {
      return item.codi === grauCode;
    });
  }

  function deselectFamiliaFromAriFilter(familiaCode, parentIndex) {
    _.remove($ctrl.ariFilter[parentIndex].estudis, function (item) {
      return (
        _.filter(item.parent, function (o) {
          return o === familiaCode;
        }).length > 0
      );
    });
    _.remove($ctrl.ariFilter[parentIndex].families, function (item) {
      return _.includes(item.codis, familiaCode);
    });
  }

  function deleteFamiliesFromMultiselect(grauCode, parentIndex) {
    var parentCode = $ctrl.ariFilter[parentIndex].tipus.codi;
    var positionsToRemove = [];
    for (var index in $ctrl.families[parentCode]) {
      var familia = $ctrl.families[parentCode][index];
      if (familia.parent.length === 1 && familia.parent[0] === grauCode) {
        positionsToRemove.push(index);
      } else if (familia.parent.length > 1) {
        var idx = familia.parent.indexOf(grauCode);
        if (idx > -1) {
          familia.parent.splice(idx, 1);
          familia.codis.splice(idx, 1);
        }

        if (familia.parent.length === 0) {
          positionsToRemove.push(index);
        }
      }
    }

    for (var i = positionsToRemove.length - 1; i >= 0; i--) {
      $ctrl.families[parentCode].splice(positionsToRemove[i], 1);
    }

    //reorganize array positions
    if ($ctrl.families != null && $ctrl.families[parentCode] != null) {
      for (var i = 0; i < $ctrl.families[parentCode].length; i++) {
        var idx_ = getStevenKey($ctrl.families[parentCode][i], "idx_");
        //var spc = getStevenKey(bigbackupFamilia, 'spc_');
        $ctrl.families[parentCode][i][idx_] = i;
      }
    }
  }

  function deleteEstudisFromMultiselect(parentIndex) {
    var parentCode = $ctrl.ariFilter[parentIndex].tipus.codi;
    var ciclesCode = _.flatten(_.map($ctrl.ariFilter[parentIndex].cicles, "codi"));
    var familiesCode = _.flatten(_.map($ctrl.ariFilter[parentIndex].families, "codis"));
    var positionsToRemove = [];
    for (var index in $ctrl.estudis[parentCode]) {
      var estudi = $ctrl.estudis[parentCode][index];
      var estudiParentCode = _.flatten(estudi.parent);
      if (
        !_.includes(ciclesCode, estudi.codiPla) ||
        !_.includes(familiesCode, estudiParentCode[0])
      ) {
        positionsToRemove.push(index);
      }
    }
    for (var i = positionsToRemove.length - 1; i >= 0; i--) {
      $ctrl.estudis[parentCode].splice(positionsToRemove[i], 1);
    }
  }

  function getStevenKey(familia, keyToSearch) {
    var keys = Object.keys(familia);
    return _.filter(keys, function (o) {
      if (o.match(new RegExp(keyToSearch, "g"))) {
        return o;
      }
    });
  }

  function reselectFamilies(parentIndex) {
    var parentCode = $ctrl.ariFilter[parentIndex].tipus.codi;
    var familiesCodes = _.flatten(_.uniq(_.map($ctrl.ariFilter[parentIndex].families, "codis")));
    for (var index in $ctrl.families[parentCode]) {
      var familia = $ctrl.families[parentCode][index];
      var codi = _.flatten(_.uniq(familia.codis));
      if (familiesCodes.length > 0 && _.intersection(codi, familiesCodes).length > 0) {
        $ctrl.families[parentCode][index].ticked = true;
      }
    }
  }

  function reselectEstudis(parentIndex) {
    var parentCode = $ctrl.ariFilter[parentIndex].tipus.codi;
    var estudisCodes = _.flatten(_.map($ctrl.ariFilter[parentIndex].estudis, "codis"));
    for (var index in $ctrl.estudis[parentCode]) {
      var estudi = $ctrl.estudis[parentCode][index];
      var codi = _.flatten(estudi.codis);
      if (estudisCodes.length > 0 && _.intersection(codi, estudisCodes).length > 0) {
        $ctrl.estudis[parentCode][index].ticked = true;
      }
    }
  }

  function getSelectedOptions(ariFilterNode) {
    var ciclesQuery = [];
    var familiesQuery = [];
    ciclesQuery.push(_.map(ariFilterNode.cicles, "codi"));
    familiesQuery.push(
      _.flatten(
        _.some(ariFilterNode.families, "codis")
          ? _.map(ariFilterNode.families, "codis")
          : _.map(ariFilterNode.families, "codi"),
      ),
    );
    return {
      graus: ciclesQuery,
      families: familiesQuery,
    };
  }

  function getSubEtapes(subEtapaCodi) {
    var i = 0;
    var numEnsenyaments = $ctrl.llistaEnsenyaments.length;
    var found = false;
    while (!found && i < numEnsenyaments) {
      if ($ctrl.llistaEnsenyaments[i].codi === subEtapaCodi) {
        parseSubEtapes($ctrl.llistaEnsenyaments[i], subEtapaCodi);
        found = true;
        if (subEtapaCodi === "CFP" || subEtapaCodi === "CFA" || subEtapaCodi === "ART") {
          $ctrl.families = [];
          if ($ctrl.estudis.hasOwnProperty(subEtapaCodi)) {
            $ctrl.estudis[subEtapaCodi] = [];
          }
        }
      }
      i++;
    }
  }

  function parseSubEtapes(element, parentCode) {
    if (element.tipusNode) {
      switch (element.tipusNode) {
        case "SUBSUBETAPA":
          if (
            !$ctrl.subEtapes[parentCode] ||
            $ctrl.subEtapes[parentCode].filter(function (obj) {
              return obj.literal === element.literal;
            }).length === 0
          ) {
            if ($ctrl.subEtapes[parentCode]) {
              $ctrl.subEtapes[parentCode].push(element);
            } else {
              $ctrl.subEtapes[parentCode] = new Array(element);
            }
          }
          break;
        case "MODALITAT_FAMILIA":
          if (
            !$ctrl.families[parentCode] ||
            $ctrl.families[parentCode].filter(function (obj) {
              obj.ticked = false;
              return obj.literal === element.literal;
            }).length === 0
          ) {
            if ($ctrl.families[parentCode]) {
              $ctrl.families[parentCode].push(element);
            } else {
              $ctrl.families[parentCode] = new Array(element);
            }
          }
          break;
        case "CICLE_GRAU":
          if (
            (!$ctrl.cicles[parentCode] ||
              $ctrl.cicles[parentCode].filter(function (obj) {
                return obj.literal === element.literal;
              }).length === 0) &&
            element &&
            element.codi !== "CFPE"
          ) {
            if ($ctrl.cicles[parentCode]) {
              $ctrl.cicles[parentCode].push(element);
            } else {
              $ctrl.cicles[parentCode] = new Array(element);
            }
          }
          break;
        case "ESTUDI":
          if (
            !$ctrl.estudis[parentCode] ||
            $ctrl.estudis[parentCode].filter(function (obj) {
              obj.ticked = false;
              return obj.literal === element.literal;
            }).length === 0
          ) {
            if ($ctrl.estudis[parentCode]) {
              $ctrl.estudis[parentCode].push(element);
            } else {
              $ctrl.estudis[parentCode] = new Array(element);
            }
          }
          break;
      }
    }

    if (element.subnodes && Array.isArray(element.subnodes) && element.subnodes.length > 0) {
      (element.subnodes || []).forEach(function (subNodeElement) {
        parseSubEtapes(subNodeElement, parentCode);
      });
    }
  }

  //Funcions per interactuar amb el fil Ariana
  $ctrl.deleteEnsenyamentFromAri = function (index) {
    var listIndex = _.findIndex($ctrl.llistaEnsenyaments, function (item) {
      return item.codi === $ctrl.ariFilter[index].tipus.codi;
    });
    if (listIndex >= 0) {
      $ctrl.llistaEnsenyaments[listIndex].ticked = false;
      angular.forEach($ctrl.torns[$ctrl.ariFilter[index].tipus.codi], function (item) {
        item.ticked = false;
      });
      $ctrl.ariFilter.splice(index, 1);
    }
  };

  $ctrl.deleteCursFromAri = function (tipusIndex, index) {
    // Tipus index -> Index del tipus d'ensenyament
    // Index -> Index dins de l'array de cursos de l'ensenyament
    $ctrl.ariFilter[tipusIndex].nivells.splice(index, 1);
  };

  $ctrl.deleteNaturalesaFromAri = function (tipusIndex, index) {
    // Tipus index -> Index del tipus d'ensenyament
    // Index -> Index dins de l'array de naturaleses de l'ensenyament
    $ctrl.ariFilter[tipusIndex].naturaleses.splice(index, 1);
  };

  $ctrl.deleteRegimFromAri = function (tipusIndex, index) {
    // Tipus index -> Index del tipus d'ensenyament
    // Index -> Index dins de l'array de naturaleses de l'ensenyament
    $ctrl.ariFilter[tipusIndex].regims.splice(index, 1);
  };

  $ctrl.deleteEstudiFromAri = function (tipusIndex, index) {
    $ctrl.ariFilter[tipusIndex].estudis.splice(index, 1);
    if ($ctrl.estudis["BATXLOE"]) {
      $ctrl.estudis["BATXLOE"][index].ticked = false;
    }
    if ($ctrl.estudis["PFI"]) {
      $ctrl.estudis["PFI"][index].ticked = false;
    }
    if ($ctrl.estudis["PFIE"]) {
      $ctrl.estudis["PFIE"][index].ticked = false;
    }
  };

  $ctrl.deleteCicleFromAri = function (tipusIndex, index) {
    var selectedTipus = $ctrl.ariFilter[tipusIndex].tipus.codi;
    var selectedCicles = $ctrl.ariFilter[tipusIndex].cicles[index]["codi"];
    var listIndex = _.findIndex($ctrl.cicles[selectedTipus], function (item) {
      return _.includes(selectedCicles, item.codi);
    });
    if (listIndex >= 0) {
      $ctrl.cicles[selectedTipus][listIndex].ticked = false;
      $ctrl.onCicleMultiselectItemSelected(
        $ctrl.cicles[selectedTipus][listIndex],
        selectedTipus,
      );
    }
  };

  $ctrl.deleteTornFromAri = function (tipusIndex, index) {
    var selectedTipus = $ctrl.ariFilter[tipusIndex].tipus.codi;
    var selectedCicles = $ctrl.ariFilter[tipusIndex].torns[index]["acronim"];
    var listIndex = _.findIndex($ctrl.torns[selectedTipus], function (item) {
      return _.includes(selectedCicles, item.acronim);
    });
    if (listIndex >= 0) {
      $ctrl.torns[selectedTipus][listIndex].ticked = false;
      $ctrl.ariFilter[tipusIndex].torns.splice(index, 1);
    }
    if (selectedTipus === "PFI" || selectedTipus === "PFIE") {
      $ctrl.torns[selectedTipus][index].ticked = false;
      $ctrl.ariFilter[tipusIndex].torns.splice(index, 1);
    }
  };

  $ctrl.deleteFamiliaFromAri = function (tipusIndex, index) {
    var selectedTipus = $ctrl.ariFilter[tipusIndex].tipus.codi;
    var nameKey =
      $ctrl.ariFilter[tipusIndex].families[index].nom ||
      $ctrl.ariFilter[tipusIndex].families[index].literal;
    var listIndex = _.findIndex($ctrl.families[selectedTipus], function (item) {
      return _.includes(nameKey, item.nom || item.literal);
    });
    if (listIndex >= 0) {
      $ctrl.families[selectedTipus][listIndex].ticked = false;
      $ctrl.onFamiliaMultiselectItemSelected(
        $ctrl.families[selectedTipus][listIndex],
        selectedTipus,
      );
    }
  };

  //Watchers
  $scope.$watch(
    "$ctrl.ariFilter",
    function (newVal) {
      //Cada vegada que la variable ariFilter canvia, enganxem el nou valor a una variable global de l'aplicació
      //perquè sigui accessible des del preinscripcio controller
      EnsenyamentsPreinscripcioData.setAriFilter(newVal);
      if ($rootScope.cercaClick) {
        $rootScope.$broadcast("changeActionButtonText", { text: "Actualitza la cerca" });
      }
      if ($rootScope.familiaFP === true) {
        $(
          $($($($(".midaFixeGran").get(1)).children()).get(0))
            .children()
            .get(0),
        ).css("width", "200px");
      }
    },
    true,
  );

  //Events
  $scope.$on("clearAdvancedFilter", function () {
    resetPreinscripcioFilter();
  });

  $scope.$on("setEnsenyamentFromURL", function (event, data) {
    var item = _.find($ctrl.llistaEnsenyaments, function (o) {
      return o.codi === data;
    });
    if (item !== undefined) {
      item.ticked = true;
      $ctrl.selTipusEnsenyament.push(item);
      $ctrl.onEnsenyamentItemSelected(item);
    }
  });

  $scope.$on("setCursFromURL", function (event, curs) {
    curs = parseInt(curs);
    var codiEnsenyament = $ctrl.ariFilter[0].tipus.codi;
    var selectedCurs = _.find($ctrl.nivells[codiEnsenyament], function (item) {
      return item.id === curs;
    });
    $ctrl.ariFilter[0].nivells.push(selectedCurs);
  });

  $scope.$on("setTitularitatFromURL", function (event, titularitat) {
    titularitat = parseInt(titularitat);
    var selectedNaturalesa = _.find($ctrl.naturaleses, function (item) {
      return item.id === titularitat;
    });
    $ctrl.ariFilter[0].naturaleses.push(selectedNaturalesa);
  });

  var resetAllCustomFilters = function () {
    $ctrl.cicles = [];
    $ctrl.torns = angular.copy($ctrl.torns_aux);
    $ctrl.families = [];
    $ctrl.estudis = [];
  };

  //Funció de neteja
  function resetPreinscripcioFilter() {
    EnsenyamentsPreinscripcioData.reset();
    $ctrl.ariFilter = [];
    $ctrl.selTipusEnsenyament = [];
    resetAllCustomFilters();
    addTickedToListEnsenyament();

    $("html, body").animate({ scrollTop: angular.element("#goTop").offset().top }, "slow");
  }
}

angular.module("mapes").component("cercaAvancada", {
  templateUrl: "./components/search-pre.component.html",
  controller: "CercaAvancadaController",
  bindings: {
    ensenyaments: "<",
    type: "<",
    nivells: "<",
  },
});
